import { sanitizeDialPart } from "../whatsappTestLink";

/**
 * E.164 string from a WhatsApp AI agent row (`provider_settings` phone fields).
 *
 * @param {{ provider?: string | null, provider_settings?: { country_code?: string | null, phone_number?: string | null } | null } | null | undefined} agent
 * @returns {string | null}
 */
export function getWhatsAppAgentE164(agent) {
  if (agent?.provider !== "whatsapp") {
    return null;
  }
  const cc = sanitizeDialPart(agent?.provider_settings?.country_code);
  const pn = sanitizeDialPart(agent?.provider_settings?.phone_number);
  if (!cc || !pn) {
    return null;
  }
  return `+${cc}${pn}`;
}

/**
 * WhatsApp agents that can drive Link in Bio autofill: enabled, and
 * `provider_settings` has both `country_code` and `phone_number` (e.g. manual auth).
 * Business Login agents still pending OAuth (no stored digits) are excluded.
 *
 * @param {unknown} agent
 * @returns {boolean}
 */
export function canSelectWhatsAppAgentForLinkInBio(agent) {
  return (
    Boolean(agent && typeof agent === "object") &&
    agent.provider === "whatsapp" &&
    agent.enabled === true &&
    getWhatsAppAgentE164(agent) != null
  );
}
